import { render, staticRenderFns } from "./html-text-widget.vue?vue&type=template&id=3f9c7530&scoped=true"
import script from "./html-text-widget.vue?vue&type=script&lang=js"
export * from "./html-text-widget.vue?vue&type=script&lang=js"
import style0 from "./html-text-widget.vue?vue&type=style&index=0&id=3f9c7530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9c7530",
  null
  
)

export default component.exports